module.exports = __webpack_public_path__ + "media/images/official/special_workcation_11-a1adfac241439a86ec6f27731413051f.jpg";